import ar from './ar.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import it from './it.json';
import ja from './ja.json';
import pt from './pt.json';
import ru from './ru.json';

export default {
  ar,
  de,
  en,
  es,
  fr,
  it,
  ja,
  pt,
  ru,
};
